import { Landmark } from "lucide-react";
import { EmptyState, FieldRow, SectionCard } from "@/components/coverage/coverageUi";

export default function ClaimsRcmPanel({ workspace }) {
  const claims = workspace.claims || {};
  const evidence = claims.source_evidence || workspace.eligibility_source || {};

  return (
    <div className="space-y-4" data-testid="coverage-claims-panel">
      <SectionCard title="Payer IDs & network" icon={<Landmark className="w-4 h-4 text-emerald-400" />}>
        {!claims.payer_ids?.length ? (
          <EmptyState title="No payer identifiers on this payload" />
        ) : (
          claims.payer_ids.map((row) => <FieldRow key={row.label} label={row.label} value={row.value} />)
        )}
        <FieldRow label="Network" value={claims.network || workspace.network_status} />
      </SectionCard>

      <SectionCard title="COB">
        {!claims.cob?.present ? (
          <EmptyState title="No coordination-of-benefits flags from Stedi" />
        ) : (
          claims.cob.fields.map((field) => (
            <FieldRow key={field.label} label={field.label} value={field.value} />
          ))
        )}
      </SectionCard>

      <SectionCard title="Filing / payment hints">
        {!claims.filing_hints?.length ? (
          <EmptyState title="No filing or payment messages on this payload" />
        ) : (
          claims.filing_hints.map((hint, idx) => (
            <div key={idx} className="rounded-lg border border-slate-800 p-3 text-sm text-slate-300">
              {hint.code ? (
                <p className="text-[10px] uppercase text-slate-500 font-bold">
                  {hint.kind} · {hint.code}
                </p>
              ) : null}
              <p>{hint.text}</p>
            </div>
          ))
        )}
      </SectionCard>

      <SectionCard title="PA / predetermination & billing limits">
        <FieldRow
          label="PA required"
          value={
            workspace.prior_authorization
              ? String(workspace.prior_authorization.required)
              : "Not provided"
          }
        />
        {workspace.prior_authorization?.review_type ? (
          <FieldRow label="Review type" value={workspace.prior_authorization.review_type} />
        ) : null}
        {!claims.billing_limitations?.length ? (
          <EmptyState title="No billing limitations listed" />
        ) : (
          claims.billing_limitations.slice(0, 16).map((lim, idx) => (
            <div key={idx} className="border-b border-slate-800/80 pb-2 text-sm text-slate-300">
              <p>{lim.text}</p>
              {lim.quantity ? <p className="text-xs text-slate-500">{lim.quantity}</p> : null}
            </div>
          ))
        )}
      </SectionCard>

      <SectionCard title="Clearinghouse refs">
        {!evidence || !Object.keys(evidence).length ? (
          <EmptyState title="No Stedi / eligibility source evidence on this payload" />
        ) : (
          <>
            <FieldRow label="Clearinghouse" value={evidence.clearinghouse} />
            <FieldRow label="Transport" value={evidence.transport} />
            <FieldRow label="Trace ID" value={evidence.trace_id} />
            <FieldRow label="Control number" value={evidence.control_number} />
            <FieldRow label="Eligibility search" value={evidence.eligibility_search_id} />
          </>
        )}
      </SectionCard>
    </div>
  );
}
